import { useState } from 'react';
import { ServiceOrderExportModalContent, UNSET_FILTERS } from './ServiceOrderExportModalContent';
import { DateInput, validateDateTimeFields } from '../../../../sharedComponents/dateHelper';
import { useGetServiceOrderExcelMutation } from '../../../../api/serviceOrdersApi';
import { isDate } from 'date-fns';
import { ExportModal } from '../../../../sharedComponents/export/ExportModal';

const FALL_BACK_FILE_NAME = 'service-order-export.xlsx';

const discardInvalidDateInput = (date: DateInput) => {
    return isDate(date) ? date : undefined;
};

export const ServiceOrderExportModal = () => {
    const [localFilters, setLocalFilters] = useState(UNSET_FILTERS);
    const [getExcel] = useGetServiceOrderExcelMutation();

    const resetFilters = () => setLocalFilters(UNSET_FILTERS);

    const { hasStartDateTimeError, hasEndDateTimeError, hasTimeRangeOrderError } = validateDateTimeFields(
        localFilters.startDateFilter,
        localFilters.endDateFilter,
    );

    return (
        <ExportModal
            tooltip="outboundOrderBook.serviceOrders.export.tooltip"
            modalTitle="outboundOrderBook.serviceOrders.export.title"
            filename={FALL_BACK_FILE_NAME}
            getExport={() =>
                getExcel({
                    location: localFilters.locationFilter,
                    statuses: localFilters.statusFilter,
                    serviceTypes: localFilters.serviceTypeFilter,
                    orderIssuedAtAfter: discardInvalidDateInput(localFilters.startDateFilter),
                    orderIssuedAtBefore: discardInvalidDateInput(localFilters.endDateFilter),
                })
            }
            body={
                <ServiceOrderExportModalContent
                    localFilters={localFilters}
                    setLocalFilters={setLocalFilters}
                    hasStartDateTimeError={hasStartDateTimeError}
                    hasEndDateTimeError={hasEndDateTimeError}
                    hasTimeRangeOrderError={hasTimeRangeOrderError}
                />
            }
            resetFilters={resetFilters}
            isDisabled={hasTimeRangeOrderError || hasStartDateTimeError || hasEndDateTimeError}
        />
    );
};
